import { render } from "./PricingAndMarginDataContent.vue?vue&type=template&id=4db2739f&scoped=true"
import script from "./PricingAndMarginDataContent.vue?vue&type=script&lang=js"
export * from "./PricingAndMarginDataContent.vue?vue&type=script&lang=js"

import "./PricingAndMarginDataContent.vue?vue&type=style&index=0&id=4db2739f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db2739f"]])

export default __exports__